export default __webpack_public_path__ + "static/media/ITR-66.f68ff84d.png";